<template>
  <brand-layout @changeLanguage="getItems">
    <brand-item :remove-with="removeBrand" v-for="brand in brands" :key="brand.id"
                :brand="brand"/>
    <b-col lg="12" class="text-center my-3">
      <m-pagination-400 class="text-center" :meta="pagination" :on-change-page="changePage"/>
    </b-col>
  </brand-layout>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import BrandItem from '../../components/dashboard/Brand/item'
import BrandLayout from '../../components/dashboard/Brand/layout'

export default {
  name: "Brand",
  components: {BrandItem, BrandLayout},
  computed: {
    ...mapGetters({
      brands: 'Brand/getBrands',
      pagination: 'Brand/getPagination',
    }),
  },
  methods: {
    ...mapActions({
      removeBrand: 'Brand/removeBrand'
    }),
    changePage(page) {
      this.$store.dispatch("Brand/getBrands", page);
      const currentRoute = this.$route
      this.$router.push({name: currentRoute.name, query: {...currentRoute.query, page: page}})
    },
    getItems() {
      let page = 1;
      if (this.$route.query.page != undefined) {
        page = this.$route.query.page
      }
      this.$store.dispatch('Brand/getBrands', page);
    }
  },
  mounted() {
    this.getItems()
  }
}
</script>

<style scoped>

</style>